import { memo, type JSX, type ReactNode } from 'react';
import Modal from 'react-modal';
import { XIcon } from 'lucide-react';
import { MODAL_DEFAULT_STYLES } from './constants';
import './modal.scss';

export type ModalComponentProps = {
  title?: string;
  isOpen: boolean;
  setIsOpen: (b: boolean) => void;
  body?: JSX.Element | ReactNode;
  style?: Modal.Styles;
};

const ModalComponent = memo((props: ModalComponentProps): JSX.Element => {
  const { title = '', isOpen, setIsOpen, body } = props;

  function closeModal() {
    if (typeof setIsOpen === 'function') {
      setIsOpen(false);
    }
  }

  function afterOpenModal() {}

  return (
    <Modal
      isOpen={isOpen}
      onAfterOpen={afterOpenModal}
      onRequestClose={closeModal}
      style={props.style ?? MODAL_DEFAULT_STYLES}
      contentLabel={title}
      ariaHideApp={false}
    >
      <div className="modal-title">
        {title} <button onClick={closeModal}>{<XIcon size={16} />}</button>
      </div>
      {body}
    </Modal>
  );
});

export { ModalComponent };
